module.exports = __webpack_public_path__ + "img/ico-6.719dd8ac.svg";